import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39f461ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper__filters" }
const _hoisted_2 = ["value", "id", "checked"]
const _hoisted_3 = ["for"]

import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const status = [
  { id: 'Alive', value: 'Alive' },
  { id: 'Dead', value: 'dead' },
  { id: 'Unknown', value: 'unknown' },
  { id: 'All', value: '' },
];

const valueFiltered = computed(() => store.getters.getValueFiltered);

function setValueFiltered(e: Event) {
  let newObj = { ...store.state.charactersModule.filters };
  delete newObj.page;
  store.commit('setCurrentPage', 1);
  store.commit('setFilters', {
    ...newObj,
    status: (e.target as HTMLInputElement).value,
  });
  store.dispatch('fetchCharacters');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(status, (el) => {
      return _createElementVNode("span", {
        key: el.id,
        class: "filters__radio"
      }, [
        _createElementVNode("input", {
          type: "radio",
          name: "status",
          value: el.value,
          id: el.id,
          onInput: setValueFiltered,
          checked: _unref(valueFiltered) === el.value
        }, null, 40, _hoisted_2),
        _createElementVNode("label", {
          for: el.id
        }, _toDisplayString(el.id), 9, _hoisted_3)
      ])
    }), 64))
  ]))
}
}

})